import {HttpClient, HttpEvent, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '../../core/config/api.config';
import {BASE_SERVICE} from '../../core/config/api.constants';
import {endpoint} from '../path.constants';
import {ApiResponse} from '../api-response.model';
import {Gender} from '../enum/enum.model';
import {States} from '../enum/city-state.model';
import {catchError, map, Observable, throwError} from "rxjs";


@Injectable({providedIn: 'root'})
export class BaseService {
    private readonly baseUrl = ApiConfig.getBaseUrl(BASE_SERVICE);

    constructor(private http: HttpClient) {
    }

    getBaseEnum() {
        const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        return this.http.get<ApiResponse<{ gender_type: Gender[] }>>(
            this.baseUrl + endpoint.base.enum, {headers}
        );
    }

    getCityState() {
        const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        return this.http.get<ApiResponse<States>>(
            this.baseUrl + endpoint.base.city_state, {headers}
        );
    }

    uploadDocuments(requestData: any): Observable<any> {
        const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        const url = this.baseUrl + endpoint.base.uploadFile
        return this.http.post<ApiResponse<any>>(url, requestData, {headers}).pipe(map(response => {
                if (response && !response.error && response.status_code === 200) {
                    return response.data;
                } else {
                    const errorMsg = response?.message?.message || 'Unexpected response structure';
                    return throwError(() => new Error(errorMsg));
                }
            }),
            catchError(error => error)
        );
    }

    upload(file: File): Observable<HttpEvent<any>> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('public', 'True');

        const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        const url = this.baseUrl + endpoint.base.uploadFile
        return this.http.post<ApiResponse<any>>(url, formData, {
            headers: headers,
            reportProgress: true, // Enables progress tracking
            observe: 'events'     // Allows us to see upload events
        });
    }
}
